/* istanbul ignore file */
export const track = (opts) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('hdhome-catalog-promo.submit', opts);
  }
};
